module.exports = __webpack_public_path__ + "img/ev-charging.b48f5bd8.png";